export default __webpack_public_path__ + "assets/images/491afaa604d22eb4deb7b4d0544e2a8e.png";